export const GET_PACKAGES_REQUEST = "GET_PACKAGES_REQUEST"
export const GET_PACKAGES_SUCCESS = "GET_PACKAGES_SUCCESS"
export const GET_PACKAGES_ERROR = "GET_PACKAGES_ERROR"
export const CREATE_SCREENING_REQUEST = "CREATE_SCREENING_REQUEST"
export const CREATE_SCREENING_SUCCESS = "CREATE_SCREENING_SUCCESS"
export const CREATE_SCREENING_ERROR = "CREATE_SCREENING_ERROR"
export const GET_CANDIDATE_REQUEST = "GET_CANDIDATE_REQUEST"
export const GET_CANDIDATE_SUCCESS = "GET_CANDIDATE_SUCCESS"
export const GET_CANDIDATE_ERROR = "GET_CANDIDATE_ERROR"